import { CloudCog, Network, Store, Scale, Armchair, Presentation } from "lucide-react";
import { Reveal } from "./Reveal";

const PERKS = [
  {
    icon: CloudCog,
    title: "SaaS & Cloud Credits",
    copy: "$50k+ worth of tool credits — hosting, analytics, design and dev stacks — free for enrolled student founders.",
  },
  {
    icon: Network,
    title: "Investor Network",
    copy: "Warm intros to 100+ angels and seed funds inside the frantiger ecosystem. No cold emails, ever.",
  },
  {
    icon: Store,
    title: "Brand Portfolio Access",
    copy: "Pilot with frantiger's portfolio brands, or build on verified franchise & distribution models.",
  },
  {
    icon: Scale,
    title: "Legal & IP Support",
    copy: "Incorporation, founder agreements and IP filings handled by people who have done it hundreds of times.",
  },
  {
    icon: Armchair,
    title: "Co-working Pods",
    copy: "A frantiger labs space inside your campus — whiteboards, war rooms and serious builder energy.",
  },
  {
    icon: Presentation,
    title: "Demo Days & Showcases",
    copy: "Curated demo days where student ventures pitch directly to operators, brands and investors.",
  },
];

const Perks = () => (
  <section id="perks" className="blueprint-grid-dark bg-[#0A0D14] py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <span className="font-mono-x text-xs uppercase tracking-[0.25em] text-[#0055FF]">
          / THE SOVEREIGN ECOSYSTEM
        </span>
        <h2 className="mt-5 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-white max-w-3xl leading-tight">
          Exclusive access. Real discounts.{" "}
          <span className="font-serif-accent text-[#0055FF]">Unfair advantages.</span>
        </h2>
        <p className="mt-5 text-base text-white/55 max-w-2xl leading-relaxed">
          Every student enrolled in frantiger labs unlocks a stack of perks built
          from a decade of consulting relationships.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {PERKS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 3) * 0.08}>
            <div
              data-testid={`perk-card-${i + 1}`}
              className="group h-full p-7 border border-white/10 bg-white/[0.03] backdrop-blur-sm hover:border-[#0055FF] hover:bg-[#0055FF]/10 transition-all duration-300"
            >
              <p.icon className="w-7 h-7 text-[#0055FF]" strokeWidth={1.75} />
              <h3 className="mt-5 font-display font-semibold text-lg text-white tracking-tight">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-white/55 leading-relaxed">{p.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Perks;
